module.exports = __webpack_public_path__ + "static/media/recenter.1e6c06a6.svg";